import * as React from 'react';
import Box from '@mui/material/Box';
import { Grid } from '@mui/material';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Ver_Valores, genera_formulario, conexiones, AExcell} from '../../../constantes';
import { Form_todos, Titulos_todos,} from '../../../constantes/formularios';
import Cargando from '../../../componentes/esperar/cargar';
import Formulario from '../../../componentes/herramientas/formulario';
import { PieChart } from '@mui/x-charts/PieChart';
import moment from 'moment';
import Tabla from '../../../componentes/herramientas/tabla';
import { Stack } from 'react-bootstrap';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  margin: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default function Estadisticas(props) {
  const [state, setState]= React.useState({esperar:false, datos:[]});
  const cambiarState = (nuevostate)=>{
      setState({...state, ...nuevostate, cambio:true})
  }
  let Formularios;
  const {Config}= props;
  const Ver_data = async(periodo, formulario=null)=>{
      cambiarState({esperar:true});
    
      var y = new Date().getFullYear();
      var y1= Number(y)-1;
      let actual = `${y1}-${y}`;
      periodo=periodo ? periodo.periodo : actual;
      props.socket.emit('Inscritos',{periodo});
    //   let resultado = await conexiones.Inscritos({periodo});
    //   console.log(resultado);
      Formularios= formulario!==null ? formulario : Formularios;
    //   let resultado = await conexiones.Leer_C(['uecla_Mensualidad'],{uecla_Mensualidad:{"valores.periodo":periodo}});//await conexiones.Solvencias({periodo});
      
     // if (resultado.Respuesta==='Ok'){
    //     let datosE=[
    //         { id: 0, value: 0, label: 'REGULARES' },
    //         { id: 1, value: 0, label: 'NUEVO INGRESO' },
    //         { id: 2, value: 0, label: 'REINGRESO' },
    //         { id: 3, value: 0, label: 'REPITIENTE' },
    //         { id: 4, value: 0, label: 'OTRO' },
    //     ];
    //     let datos = resultado.datos.uecla_Mensualidad.map(val=>val.valores).filter(f=>f._id_estudiante.indexOf("Abono")===-1).sort((a,b) => Number(a.recibo)> Number(b.recibo) ?  1 : -1);;
    //     for (var i=0; i<datos.length;i++){
    //         if (datos[i]._id_estudiante.indexOf('Abono')===-1){
    //             datos[i]={
    //                 _id_estudiante:datos[i]._id_estudiante,
    //                 cedula:datos[i].cedula,
    //                 nombres:datos[i].nombres,
    //                 apellidos:datos[i].apellidos,
    //                 periodo:datos[i].periodo,
    //                 grado:datos[i].grado,
    //                 seccion:datos[i].seccion,
    //             }
    //             resultado = await conexiones.Leer_C(['uecla_Estudiante'],{uecla_Estudiante:{"_id":datos[i]._id_estudiante}});
    //             if (resultado.datos && resultado.datos.uecla_Estudiante && resultado.datos.uecla_Estudiante.length!==0){
    //                 datos[i].tipoestudiante=resultado.datos.uecla_Estudiante[0].valores.tipoestudiante;
    //                 if (datos[i].tipoestudiante && datos[i].tipoestudiante._id===0){
    //                     datosE[0].value+=1;// regulares++;
    //                 }else if (datos[i].tipoestudiante && datos[i].tipoestudiante._id===1){
    //                     datosE[1].value+=1;//nuevo++;
    //                 }else if (datos[i].tipoestudiante && datos[i].tipoestudiante._id===2){
    //                     datosE[2].value+=1;//reingreso++;
    //                 }else if (datos[i].tipoestudiante && datos[i].tipoestudiante._id===3){
    //                     datosE[3].value+=1;//repitiente++;
    //                 }else{
    //                     datosE[4].value+=1;//otro++;
    //                 }
                    
    //                 resultado = await conexiones.Resumen(resultado.datos.uecla_Estudiante[0].valores);
    //                 if (resultado.Respuesta==='Ok'){
    //                     let recibos = resultado.recibos.map(val=> val);
    //                     let pos=-1;
    //                     recibos.map((val,i)=>{
    //                         const p = val.valores.mensualidades.meses.findIndex(f=> f.periodo===periodo && f.value==='inscripcion')
    //                         if (p!==-1){
    //                             pos=i;
    //                         }
    //                         return val
    //                     })
    //                     if (pos!==-1){
    //                         datos[i].recibo = recibos[pos].valores.recibo;
    //                         datos[i].fechainscripcion = moment(recibos[pos].createdAt).format('DD/MM/YYYY');
    //                     }
    //                 }
    //             }
                
    //         }
    //         // console.log(datos[i]._id_estudiante);
    //     }
    //     let {datos, datosE}= resultado;
    //     console.log(datos, datosE);
        const titulos = await Titulos_todos(`Titulos_Inscritos`, Config)
        cambiarState({  formulario,titulos})
    //   }else{
          //cambiarState({esperar:false});
    //   }
  
  }

  const ReporteM = () =>{
    const datos = state.datos.map(val=>{
        const data = val;
        
        return {
        CEDULA:data.cedula,
        NOMBRES:data.nombres,
        APELLIDOS:data.apellidos,
        'GRADO':data.grado,
        'SECCION':data.seccion,
        'PERIODO':data.periodo ? data.periodo : "",
        RECIBO:data.recibo,
        'FECHA':data.fechainscripcion,
        'TIPO DE ESTUDIANTE':data.tipoestudiante ? data.tipoestudiante.titulo : "",
        
        }
    })
    
    const nombre = state.datos.length!==0 ? `Inscritos-${state.datos[0].periodo}.xlsx` : `Inscritos.xlsx`
    AExcell(datos,'Inscritos', nombre)
  }
  const Inicio = async() =>{
    let formulario = await genera_formulario({valores:{}, campos: Form_todos('Form_filtro_solvencias') })
    const periodos =formulario.titulos[0].value.periodo.lista.sort((a,b) => a.periodo> b.periodo ? -1 : 1)
    formulario.titulos[0].value.periodo.value= periodos[0];
    formulario.titulos[0].value.periodo.lista= periodos;
    delete formulario.titulos[0].value.grado
    const titulos = await Titulos_todos(`Titulos_Inscritos`, Config)
    cambiarState({esperar:false, formulario, titulos})
    Formularios= formulario;
    Ver_data(periodos[0], formulario)
  }
 
  React.useEffect(()=>{
    props.socket.on("Progreso",data=>{
        
        cambiarState({esperar:true, total:data.total, progreso:data.progreso});
    })
    props.socket.on("Inscritos",async(data)=>{
        console.log("Inscritos", data);
        const titulos = await Titulos_todos(`Titulos_Inscritos`, Config)
        cambiarState({esperar:false, total:data.total, progreso:0, datos:data.datos, datosE:data.datosE, titulos});
    })
    Inicio();
    return ()=>{
        props.socket.off("Progreso");
        props.socket.off("Inscritos");
    }
  }, [props])
  const color =  Ver_Valores().config.Estilos.Input_icono_t ? Ver_Valores().config.Estilos.Input_icono_t : {};
  return state.esperar ? <Box sx={{ flexGrow: 1, height:window.innerHeight*0.8}}><Cargando open={state.esperar} progreso={state.progreso} Config={Config}/> </Box>:(
    <Box sx={{ flexGrow: 1, height:window.innerHeight*0.8}}>
      <Grid container spacing={1}>
        <Grid xs={2}/>
        <Grid xs={8}>
            <Item><Formulario {...state.formulario}/></Item>
        </Grid>
        <Grid xs={2}/>
        <Grid xs={3}/>
        
        <Grid xs={6}>
            <Item>
                INSCRITOS ({state.datos ? state.datos.length : 0})
                <PieChart
                    series={[
                    {
                        data: state.datosE ? state.datosE : [],
                        highlightScope: { faded: 'global', highlighted: 'item' },
                        faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                        innerRadius: 0,
                        outerRadius: 80,
                        paddingAngle: 0,
                        cornerRadius: 5,
                        startAngle: 0,
                        endAngle: 360,
                        cx: 100,
                        cy: 100,
                    },
                    
                    ]}
                    width={400}
                    height={230}
                />
            </Item>
        </Grid>
        <Grid xs={3}/>
        <Grid xs={12}>
            <Item>
                <Tabla  Titulo={"Inscritos"}
                    alto={Ver_Valores().tipo==='Web' ? window.innerHeight * 0.64 : window.innerHeight * 0.63}
                    Config={Config ? Config : Ver_Valores().config}
                    titulos={state.titulos}
                    table={'uecla_'}
                    cantidad={state.datos ? state.datos.length : 0}
                    // cargacompleta={Actualizar_data}
                    datos={ state.datos ? state.datos :[]} //state.datos ? state.datos :
                    // Accion={mostrar ? null : Abrir}
                    cargaporparte={false }
                    Noactualizar
                    sinpaginacion={true}
                    acciones={
                        <Stack direction="row" spacing={0.5}>
                            <IconButton color={'primary'} title={'Reporte'} onClick={ReporteM}>
                                <Icon style={color}>assignment</Icon>
                            </IconButton>
                        </Stack>
                    }
                        
                />
                {/* <Dialogo  {...dialogo} config={Ver_Valores().config}/>
                <Dialogo  {...dialogo1} config={Ver_Valores().config}/>
                <Cargando open={state.esperar} config={Ver_Valores().config}/> */}
                
            {/* </div> */}
            </Item>
        </Grid>
      </Grid>
    </Box>
  );
}
